import { Button } from "primereact/button";
import { useState } from "react";

const AnulaPuesto = ({ puesto, onAnular }) => {

    const [procesando, setProcesando] = useState(false)
    
    const handleClick = () => {
        setProcesando(true)
        onAnular()
    }

    return (
        <div className="card">
            <h5>Anulacion de Puesto</h5>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">Nombre Proyecto:</div>
                <div className="field col-12 md:col-3">
                    <span className="inline-block w-full px-3 py-2 bg-gray-100 text-gray-500 border border-gray-300 rounded-md cursor-not-allowed select-none">
                        {puesto.proyecto?.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-3">Sigla Proyecto:</div>
                <div className="field col-12 md:col-3">
                    <span className="inline-block w-full px-3 py-2 bg-gray-100 text-gray-500 border border-gray-300 rounded-md cursor-not-allowed select-none">
                        {puesto.proyecto?.sigla}
                    </span>
                </div>

                <div className="field col-12 md:col-3">Nombre Puesto:</div>
                <div className="field col-12 md:col-3">
                    <span className="inline-block w-full px-3 py-2 bg-gray-100 text-gray-500 border border-gray-300 rounded-md cursor-not-allowed select-none">
                        {puesto.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-3">Sigla Puesto:</div>
                <div className="field col-12 md:col-3">
                    <span className="inline-block w-full px-3 py-2 bg-gray-100 text-gray-500 border border-gray-300 rounded-md cursor-not-allowed select-none">
                        {puesto.sigla}
                    </span>
                </div>
                <div className="field col-12 md:col-8"></div>
                <div className="field col-12 md:col-4">
                    <Button label='Confirma Anular' onClick={handleClick} loading={procesando} />
                </div>
            </div>
        </div>
    );
};

export default AnulaPuesto;
